import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
// import bg2 from "../../assets/AboutUs/more-button/i-bg2.jpg";
import bg2 from "../assets/AboutUs/more-button/i-bg2.jpg"

const MoreButton = () => {
  const navigate = useNavigate();

  const handleMoreButtonClick = () => {
    // Function to handle the More button click
    navigate("/about"); // Navigate to the About Us component
  };
  return (
    <Box
      id="image"
      sx={{
        position: "relative",
        width: "100%",
        backgroundSize: "cover",
        // borderRadius: "10px",
        backgroundImage: `url(${bg2})`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        // minHeight: "300px", // Set a minimum height for the container
        height: { xs: "300px", sm: "200px", md: "100px" },
      
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          //   textAlign: "center",
          gap: "10px", // Add spacing between text and button
          width: "100%",
        }}
      >
        <Typography
          variant="body1"
          color="white"
          sx={{ flex: "1" }} // Take full width on small screens, share width with button on larger screens
        >
          RESELTECH has a rigorous, efficient, and professional technical
          service team, including technical consultation, solution design,
          downhole tool customization, on-site technical services, and oil and
          water control effects evaluation.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ flexShrink: 0 }}
          endIcon={<ArrowForward />}
          onClick={handleMoreButtonClick}
        >
          {" "}
          {/* Prevent button from shrinking */}
          More
        </Button>
      </Box>
    </Box>
  );
};

export default MoreButton;
